<template>
    <div class="loading-spinner" v-if="!itemlists">
        <base-spinner></base-spinner>
    </div>
    <div v-else>
       
        <div class="list_wrap" v-if="itemlists">
            <div v-for="(item, index) in itembuylists.data" :key="index" class="item_block" :class="{'isUseable':item.remain>0}">     
                <div class="left_part">
                    <div class="item_name">
                        {{item.item_title}}
                    </div>
                    <div class="price">
                        <template v-if="item.item_price > 0">
                            {{addComma(item.item_price)+' 원'}}
                        </template>
                        <template v-else>
                            {{addComma(Math.abs(item.item_point))+' P'}}
                        </template>
                    </div>
                    <div class="time_count">
                        <span><display-time :time="item.created_at"/></span>
                        <span>구매 [{{item.count}}]</span>  
                        <span  v-if="item.remain > 0"> / 남은갯수 <span class="remain">{{item.remain}}</span></span>                     
                    </div>
                </div>               
                <div class="right_part">
                  
                    <div class="btn_part">
                        <div class="btn_use" v-if="item.count === item.remain && item.item_price> 0 && item.state==1 ">
                            <base-button-sm  mode="darkblue" @click="refund(item.id)">환불신청</base-button-sm>
                        </div>  
                        <div class="btn_use" v-if="item.state===1 && item.remain > 0">
                            <base-button-sm mode="orange" @click="popUse(item.id)">사용하기</base-button-sm>
                        </div>
                        <span v-else>
                            {{itemState[item.state]}}
                        </span>  
                        
                                               
                    </div>
                </div>            
            </div>   
          
        </div>
        <div class="paginate" ><paginate store="item" collection="itemBuy"  @paging="getBuyItems" :isMobile="true"/></div>
    </div>
     <!-- 항목 테이블 -->
        <pop-item :show="ckItemUse" @close="confirm" :itemId="currentItemId" :selcomp="selcomponent" :isMobile="true">
            <template v-slot:header>
               <div>{{poptitle}}</div>
            </template>
        </pop-item>
</template>
<script>
import { myItemBuy } from '@/components/mixins/pages/myItemBuy.js'
export default {
    name:'mobile_myItemBuy',
    props:[
        
    ],
    data(){
        return{

        }
    },
    mixins:[
        myItemBuy
    ],
    components:{

    },
    mounted() {
    },
    methods:{
    }
}
</script>
<style lang="scss" scoped>
.list_wrap{
    padding: 10px 20px 0;
    .item_block{
        display: flex;
        justify-content: space-between;
        border-bottom:1px solid #f2f2f2;
        padding:10px 0;
        .left_part{          
           .item_name{           
                overflow: hidden;         
                line-height: 19px;           
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 14px;
                font-weight: 700;
                margin-bottom: 3px; 
            }
            .price{
                display: inline-block;    
            }
            .time_count{
                display: flex;
                margin-top:3px;
                span{
                    display: inline-block;
                    padding-right: 5px;
                }
                .remain{
                    background: #0d4e7c; 
                    border-radius: 5px;  
                    color:#b3d9ed;
                    padding:0 5px;
                }
            }
        }
        .center_part{
            .remain{
                border: 1px solid #d8d8d8;
                border-radius: 5px;
                text-align: center;
                .remain_header{
                    padding:2px 5px;
                    background: #0d4e7c;
                    color:#b3d9ed;
                }
                .remain_count{
                    font-weight: bold;
                    font-size: 16px;
                    line-height: 30px;
                }
            }
        }
        .right_part{
            display: flex;
           
            .btn_part{
                display: flex;
                align-items: center;
                .btn_use{
                    height: 80%;
                    margin:0 2px;
                }
            }
        }
    }
}
.paginate{
    margin-top:20px;
}
</style>